import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import { GetFullMediaPath, numberFormatterLabel } from "../../helper/method";
import StatusVisit from "../../components/StatusVisit";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { statusMock, tokenMock, typeMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import PenSquare from "../../components/svg/PenSquare";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import Chat from "../../components/svg/Chat";
import Clapper from "../../components/svg/Clapper";
import Folder from "../../components/svg/Folder";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";

export default function Courses() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState("");
  const { data, isLoading } = $api.useQuery("get", "/site-api/v1/course/");
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/course/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("لیست دوره ها");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteCourseItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "تصویر دوره",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <div className="aspect-square w-16 rounded-lg overflow-hidden">
          <img
            src={GetFullMediaPath(record.image)}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ),
    },
    {
      title: "عنوان دوره",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "قیمت دوره",
      dataIndex: "price",
      key: "price",
      render: (_, record) => <span>{numberFormatterLabel(+record.price)}</span>,
    },
    {
      title: "قیمت دوره با تخفیف",
      dataIndex: "off_price",
      key: "off_price",
      render: (_, record) => (
        <span>
          {numberFormatterLabel(record.price_with_discount ?? 0) ?? "-"}
        </span>
      ),
    },
    {
      title: "دسته بندی",
      key: "category",
      dataIndex: "category",
      filters: data?.data?.map((e) => ({
        text: e.category,
        value: e.u_id,
      })),
      onFilter: (value, record) => record.u_id.indexOf(value as string) === 0,
    },
    {
      title: "وضعیت دوره",
      dataIndex: "type",
      key: "type",
      filters: typeMock.map((e) => ({
        text: e.label,
        value: e.value,
      })),
      onFilter: (value, record) =>
        record.type.toString().indexOf(value as string) === 0,
      render: (_, record) => (
        <span>{typeMock?.find((e) => e.value === record.type)?.label}</span>
      ),
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-1">
          {record.type === 1 || record.type === 3 ? (
            <Tooltip title="اتصال دوره">
              <ButtonLinkIconSvg
                to={`/connected-course/${record.u_id}?type=${record.type}&department_u_id=${record.department_u_id}`}
                icon={<Folder />}
                className="text-primary-500!"
              />
            </Tooltip>
          ) : (
            ""
          )}
          {record.type === 2 ? (
            <Tooltip title="لیست ویدیو ها">
              {/* <ButtonLinkIcon
                to={`/list-of-seasons/${record.u_id}/?name=${record.title}`}
                icon="solar:clapperboard-play-outline"
                className="text-primary-500!"
              /> */}
              <ButtonLinkIconSvg
                to={`/list-of-seasons/${record.u_id}/?name=${record.title}`}
                icon={<Clapper />}
                className="text-primary-500!"
              />
            </Tooltip>
          ) : (
            ""
          )}
          {/* <ButtonLinkIcon
            to={{
              pathname: "/courses/add-course",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            to={{
              pathname: "/courses/add-course",
              search: "?u_id=" + record.u_id,
            }}
            icon={<PenSquare />}
            className="text-primary-500!"
          />
          {/* <ButtonLinkIcon
            to={`/courses/comment-list/${record.u_id}`}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            to={`/courses/comment-list/${record.u_id}`}
            icon={<Chat />}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId(record.u_id);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId(record.u_id);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title="حذف از دوره ها ؟"
        description="حذف این دوره باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          mutate(
            {
              params: {
                query: {
                  course_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId("");
                setIsOpen(false);
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
      <div className="w-full flex justify-end col-span-full sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/courses/add-course"} className="button-style">
          افزودن دوره
        </Link>
      </div>

      <div className="w-full flex-1 col-span-full">
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable
            props={{
              className: "min-w-0!",
            }}
          >
            <Table<components["schemas"]["SiteCourseItem"]>
              scroll={{
                x: "max-content",
              }}
              columns={columns}
              dataSource={data?.data}
              loading={isLoading}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
